export default __webpack_public_path__ + "media/images/images/banner/banner-36-98303545b1e8fb7752e6f23c69d05597.jpg";